// extracted by mini-css-extract-plugin
module.exports = {"Navbar":"Navbar_Navbar__1npjJ","Box-Shadow":"Navbar_Box-Shadow__5rbHG"};